// extracted by mini-css-extract-plugin
export default {"services":"Service_services__SKpCw","content":"Service_content__6exDM"};